export default __webpack_public_path__ + "static/media/Icons_Email Sent Icon.a5a0fb47.svg";